module.exports = __webpack_public_path__ + "static/7-1f85e92d8ff443980bc0f83ad7b23b60.woff";